import { useCallback, useEffect, useState } from 'react';

import { PartnerDocsStatus } from './partnerDocRequirements';
import { fetchPartnerDocsStatus, PARTNER_DOCS_CHANGED } from './partnerDocsApi';

/** The case's partner-document status; reloads whenever something on the page changes it. */
export function usePartnerDocsStatus(
  funeralId: string | number | undefined,
  enabled = true
) {
  const [status, setStatus] = useState<PartnerDocsStatus | null>(null);
  const reload = useCallback(() => {
    if (!funeralId || !enabled) return;
    fetchPartnerDocsStatus(funeralId)
      .then(setStatus)
      .catch(() => setStatus(null));
  }, [funeralId, enabled]);
  useEffect(() => {
    reload();
    const onChange = (e: Event) => {
      if (String((e as CustomEvent).detail?.funeralId) === String(funeralId))
        reload();
    };
    window.addEventListener(PARTNER_DOCS_CHANGED, onChange);
    return () => window.removeEventListener(PARTNER_DOCS_CHANGED, onChange);
  }, [reload, funeralId]);
  return { status, setStatus, reload };
}
